import React from "react";
//
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import { useExpertMessageContext } from "../../../expert/hooks/expert-message/ExpertMessageContext";
import DataTable from "@limitless/modern/data-display/table/DataTable.js";
import Typography from "@limitless/modern/data-display/typography/Typography";
import { renderValueCell } from "../../utils/table-cell-renderers/TableCellRenderers";
const useStyles = makeStyles(theme => {
  return {
    tableContainer: {
      border: theme.palette.border,
      borderRadius: 5,
      padding: 0,
      margin: "auto"
    }
  };
});
const SecureData = () => {
  const {
    getCustomerSecureData,
    customerSecureData
  } = useExpertMessageContext();
  const classes = useStyles();
  React.useEffect(() => {
    getCustomerSecureData();
  }, []);
  const columns = [{
    name: "valueName",
    label: "Data Type",
    options: {
      sort: false
    }
  }, {
    name: "value",
    label: "Value(click to copy)",
    options: {
      sort: false,
      customBodyRender: v => renderValueCell(v, "value"),
      setCellProps: () => {
        return {
          style: {
            maxWidth: 120
          }
        };
      }
    }
  }];
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      lineHeight: 1,
      paddingTop: 16,
      height: 48
    }
  }, "Secure Information"), (customerSecureData === null || customerSecureData === void 0 ? void 0 : customerSecureData.length) > 0 ? /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignContent: "flex-start",
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(DataTable, {
    columns: columns,
    data: customerSecureData
  })) : /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignContent: "flex-start",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "No secured information available")));
};
export default SecureData;